import { Navigate, Route, Routes } from 'react-router-dom';

import Layout from './layout';

import ContactUs from '../Pages/ContactUs';
import HomePage from '../Pages/Homepage';
import Profile from '../Pages/Profile';
import Reservations from '../Pages/Reservations';
import SignIn from '../Pages/SignIn';
import SignUp from '../Pages/SignUp';

/// /// Organizer
import EditCourt from '../Pages/EditCourt';
import MyReservations from '../Pages/MyReservations';
import OrganizerAccount from '../Pages/Organizer';
import OrganizerLogin from '../Pages/Organizer/Login';
import SelectCourt from '../Pages/Organizer/selectCourt';
import OrganizerReservations from '../Pages/OrganizerReservations';
import OrganizerLayout from './organizerLayout';

/// /// Admin
import AdminActions from '../Pages/Admin';
import AdminAuth from '../Pages/Admin/auth';
import TermsAndConditions from '../Pages/Terms&Conditions';
import AdminLayout from './adminLayout';

const Router = () => (
  <Routes>
    {/* Main layout routes */}
    <Route path='/' element={<Layout />}>
      <Route index element={<HomePage />} />
      <Route path='signup' element={<SignUp />} />
      <Route path='signin' element={<SignIn />} />
      <Route path='profile' element={<Profile />} />
      <Route path='reserve-court/:courtId' element={<Reservations />} />
      <Route path='my-reservations' element={<MyReservations />} />
      <Route path='contact-us' element={<ContactUs />} />
      <Route path='terms-conditions' element={<TermsAndConditions />} />

      <Route path='*' element={<Navigate to='/' />} />
    </Route>

    {/* Organizer routes */}
    {/* <Route path='/organizers/login' element={<OrganizerLogin />} /> */}

    <Route path='/organizers' element={<OrganizerLayout />}>
      <Route index element={<OrganizerLogin />} />
      <Route path='account/:courtId' element={<OrganizerAccount />} />
      <Route path='select-court' element={<SelectCourt />} />
      <Route path='court/:courtId' element={<EditCourt />} />
      <Route path='reservations/:courtId' element={<OrganizerReservations />} />
    </Route>

    {/* Admin routes */}
    <Route path='/admin' element={<AdminLayout />}>
      <Route index element={<AdminAuth />} />
      <Route path='actions' element={<AdminActions />} />
    </Route>
  </Routes>
);

export default Router;
